import { useApp } from '@/context/AppContext';
import {
  classificationName as _classificationName,
  entityName as _entityName,
  productName as _productName,
} from '@/utils/formatters';

export function useProductName(id: string | null | undefined): string {
  const { catalog } = useApp();
  return id ? _productName(catalog, id) : '';
}

export function useEntityName(
  productId: string | null | undefined,
  entityId: string | null | undefined,
): string {
  const { catalog } = useApp();
  return productId && entityId ? _entityName(catalog, productId, entityId) : '';
}

export function useClassificationName(id: string | null | undefined): string {
  const { catalog } = useApp();
  return id ? _classificationName(catalog, id) : '';
}
